import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'highlight',
  standalone: true
})
export class HighlightPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string, terms: string[], cssClass: string = 'highlight'): SafeHtml {
    if (!value || !terms?.length) {
      return value;
    }

    let escapedTerms = terms
      .filter(t => !!t)
      .map(t => t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')); // escape regex special chars

    if (escapedTerms.length === 0) {
      return value;
    }

    const regex = new RegExp(`(${escapedTerms.join('|')})`, 'gi');

    const highlighted = value.replace(regex, match => {
      return `<span class="${cssClass}">${match}</span>`;
    });

    return this.sanitizer.bypassSecurityTrustHtml(highlighted);
  }
}
